import { DOCUMENT } from '@angular/common';
import { Injectable,Inject } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class LinkService {

constructor(@Inject(DOCUMENT) private doc
) {
}

/**
* Inject the State into the bottom of the <head>
*/
createLinkForCanonicalURL() {
  let existingCanonicalLink = this.doc.querySelector('link[rel="canonical"]');

  if (existingCanonicalLink) {
    // If it exists, remove it
    existingCanonicalLink.remove();
  }

  // Create a new <link> element for the canonical URL
  let link = this.doc.createElement('link');
  link.setAttribute('rel', 'canonical');

  // Ensure the URL uses https
  let canonicalUrl = this.doc.URL.replace(/^http:/, 'https:');
  link.setAttribute('href', canonicalUrl);

  this.doc.head.appendChild(link);
}
}